// import Icon from '@ant-design/icons';
// import BrokerIcon from '@components/Icons/BrokerIcon';
import IconYoutube from '@components/Icons/iconYoutube';
import QuestionAnswerIcon from '@components/Icons/QuestionAnswerIcon';
import ResumeIcon from '@components/Icons/ResumeIcon';
import ReviewIcon from '@components/Icons/ReviewIcon';
import { IconTopicTree } from '@components/Menu/MenuMobile/IconSvg';
import React from 'react';

import {
  IconAcademy,
  IconAgency,
  IconAnonymousUser,
  IconBannerAds,
  IconBonus,
  IconBroker,
  IconBrokerData,
  IconCollaborator,
  IconComment,
  IconComponent,
  IconContest,
  IconEbook,
  IconEditor,
  IconFile,
  IconHttp,
  IconMail,
  IconMailHistory,
  IconMobile,
  IconPayment,
  IconRebates,
  IconRedirect,
  IconReward,
  IconRoles,
  IconSetting,
  IconStory,
  IconTestcase,
  IconThechadigitalEnquiry,
  IconThumbnail,
  IconTracking,
  IconUser,
  IconWpPost,
  IconWpPostAudit,
  VideoAcademyIcon,
  VideoAcademyOrderIcon,
  VsaTechnique
} from './Icon';

// const components = <Icon type="deployment-unit" className="icon" />;

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    key: 'admin/manage-user',
    link: '/admin/manage-user',
    icon: <IconUser />,
    content: 'Tài khoản',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/anonymous-user-data',
    link: '/admin/anonymous-user-data',
    icon: <IconAnonymousUser  />,
    content: 'Thông tin KH',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/agency',
    link: '/admin/agency',
    icon: <IconAgency  />,
    content: 'Môi giới',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-comment',
    link: '/admin/manage-comment',
    icon: <IconComment />,
    content: 'Bình luận',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-user-free-book',
    link: '/admin/manage-user-free-book',
    icon: <IconEbook />,
    content: 'KH nhận Ebook',
    roles: ['ROLE_SYSTEM_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-month-bonus',
    link: '/admin/manage-month-bonus',
    icon: <IconBonus />,
    content: 'Tiền thưởng CTV',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-payment',
    link: '/admin/manage-payment',
    icon: <IconPayment />,
    content: 'Thanh toán',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-role-permission',
    link: '/admin/manage-role-permission',
    icon: <IconRoles />,
    content: 'Vai trò - Quyền',
    roles: ['ROLE_SYSTEM_ADMIN'],
  },
  // {
  //   key: 'manage-voucher',
  //   link: '/manage-voucher',
  //   icon: <IconVoucher />,
  //   content: 'Voucher',
  //   roles: ['ROLE_SYSTEM_ADMIN'],
  // },

  {
    key: 'admin/manage-devices',
    link: '/admin/manage-devices',
    icon: <IconMobile />,
    content: 'Thiết bị',
    roles: ['ROLE_SYSTEM_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-config-redirect',
    link: '/admin/manage-config-redirect',
    icon: <IconRedirect />,
    content: 'Config Redirect',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-document',
    link: '/admin/manage-document',
    icon: <IconFile />,
    content: 'Tài liệu',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-broker',
    link: '/admin/manage-broker',
    icon: <IconBroker />,
    content: 'Broker',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-broker-data',
    link: '/admin/manage-broker-data',
    icon: <IconBrokerData />,
    content: 'Broker Data',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-test-case',
    link: '/admin/manage-test-case',
    icon: <IconTestcase />,
    content: 'Testcase',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-thumbnail',
    link: '/admin/manage-thumbnail',
    icon: <IconThumbnail />,
    content: 'Thumbnail',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-wp-post',
    link: '/admin/manage-wp-post',
    icon: <IconWpPost />,
    content: 'WP Post',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-wp-post-audit',
    link: '/admin/manage-wp-post-audit',
    icon: <IconWpPostAudit />,
    content: 'WP Post Audit',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-reward-ladder',
    link: '/admin/manage-reward-ladder',
    icon: <IconReward />,
    content: 'Reward Ladder',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-mail-template',
    link: '/admin/manage-mail-template',
    icon: <IconMail />,
    content: 'Mail Template',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-trading-academy-lesson',
    link: '/admin/manage-trading-academy-lesson',
    icon: <IconAcademy />,
    content: 'Bài viết Khóa học',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-user-tracking',
    link: '/admin/manage-user-tracking',
    icon: <IconTracking />,
    content: 'User Tracking',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-thechaddigital-enquiry',
    link: '/admin/manage-thechaddigital-enquiry',
    icon: <IconThechadigitalEnquiry />,
    content: 'The Chad Digital Enquiry',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-mail-history',
    link: '/admin/manage-mail-history',
    icon: <IconMailHistory />,
    content: 'Mail History',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-configuration-settings',
    link: '/admin/manage-configuration-settings',
    icon: <IconSetting />,
    content: 'Cài đặt',
    roles: ['ROLE_SYSTEM_ADMIN'],
  },
  {
    key: 'admin/manage-post-check-seo',
    link: '/admin/manage-post-check-seo',
    icon: <IconHttp />,
    content: 'HTTP Status',
    roles: ['ROLE_SYSTEM_ADMIN'],
  },
  {
    key: 'admin/manage-components',
    link: '/admin/manage-components',
    icon: <IconComponent />,
    content: 'Components',
    roles: ['ROLE_SYSTEM_ADMIN'],
  },
  {
    key: 'admin/manage-collaborator',
    link: '/admin/manage-collaborator',
    icon: <IconCollaborator />,
    content: 'Collaborator',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-banner-ads',
    link: '/admin/manage-banner-ads',
    icon: <IconBannerAds />,
    content: 'Banner Ads',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-open-resume-count',
    link: '/admin/manage-open-resume-count',
    icon: <ResumeIcon />,
    content: 'Open CV Count',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-customer-review',
    link: '/admin/manage-customer-review',
    icon: <ReviewIcon />,
    content: 'Customer Review',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-trader-discussion',
    link: '/admin/manage-trader-discussion',
    icon: <QuestionAnswerIcon />,
    content: 'Hỏi đáp thực chiến',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-cv',
    link: '/admin/manage-cv',
    icon: <ResumeIcon />,
    content: 'Quản lí CV',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-topic-group',
    link: '/admin/manage-topic-group',
    icon: <IconTopicTree />,
    content: 'Quản lí Topic',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-rebates',
    link: '/admin/manage-rebates',
    icon: <IconRebates />,
    content: 'Quản lí Rebates',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-config-youtube',
    link: '/admin/manage-config-youtube',
    icon: <IconYoutube />,
    content: 'Config Youtube',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/all-posts',
    link: '/admin/all-posts',
    icon: <IconWpPost />,
    content: 'Posts',
    roles: ['ROLE_VNREBATE_COLLABORATOR', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-wp-post-form',
    link: '/admin/manage-wp-post-form',
    icon: <IconEditor />,
    content: 'Post Editor',
    roles: ['ROLE_VNREBATE_COLLABORATOR', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-video-trading-academy',
    link: '/admin/manage-video-trading-academy',
    icon: <VideoAcademyIcon />,
    content: 'Quản lí khóa học',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-video-trading-academy-lesson',
    link: '/admin/manage-video-trading-academy-lesson',
    icon: <VideoAcademyIcon />,
    content: 'Quản lí bài học',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-video-academy-feedback',
    link: '/admin/manage-video-academy-feedback',
    icon: <ReviewIcon />,
    content: 'Feedback khóa học',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-video-academy-order',
    link: '/admin/manage-video-academy-order',
    icon: <VideoAcademyOrderIcon />,
    content: 'Quản lí đơn hàng',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-vsa-technique',
    link: '/admin/manage-vsa-technique',
    icon: <VsaTechnique />,
    content: 'VSA nâng cao',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-story',
    link: '/admin/manage-story',
    icon: <IconStory />,
    content: 'Quản lý Story',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
  {
    key: 'admin/manage-contest',
    link: '/admin/manage-contest',
    icon: <IconContest />,
    content: 'Quản lý Contest',
    roles: ['ROLE_VNREBATE_ADMIN', 'ROLE_VNREBATE_ADMIN'],
  },
];
